export default __webpack_public_path__ + "static/media/pexels-kampus-production-7551658.ab164be7.jpg";